/** Motion never owns application state. Commands are applied immediately. */
export function transitionContent(update: () => void) {
  update();
}
export function reducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
export function scrollBehavior(): ScrollBehavior {
  return reducedMotion() ? 'instant' : 'smooth';
}
export function revealStep(heading: HTMLElement | null) {
  if (!heading || document.querySelector('[role="dialog"], [role="alertdialog"]')) return;
  heading.focus({ preventScroll: true });
  const top = heading.getBoundingClientRect().top;
  if (top < 96 || top > window.innerHeight * 0.65)
    heading.scrollIntoView({ block: 'start', behavior: scrollBehavior() });
}
